import React from 'react';
import { Suspense } from 'react';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router';
import mainTheme from './theme/mainTheme';
import { useCookieStore } from './store/cookieStore';

const Calendly = React.lazy(() => import('@/components/Calendly'));
const CookieBanner = React.lazy(() => import('./components/Privacy/CookieBanner'));
const Navbar = React.lazy(() => import('@/components/Navbar'));
const Footer = React.lazy(() => import('@/components/Footer'));

function App() {
  const calendly = useCookieStore((state) => state.calendly);
  
  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline />
      
      <Box sx={{ display: 'flex', flexDirection: 'column', }}
      >
        <Suspense fallback={null}>
          <Navbar />
        </Suspense>

        {/* Contenuto dinamico */}
        <Box sx={{ flexGrow: 1 }}
        >
          <Outlet />
        </Box>
        
      </Box>



      {/* Footer al fondo fondo */}
              <Box sx={{}}>
          <Suspense fallback={null}>
            <Footer  />
          </Suspense>
        </Box>



      <Suspense fallback={null}>
        <CookieBanner />
        {calendly.use && <Calendly />}
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
